import { setItemSelected } from '../services/data-service';
import imgRessource from '../images/ressource.png';
import imgAdherent from '../images/adherent.png';
import imgAccompagnateurBDO from '../images/accompagnateur-bdo.png';
import imgAccompagnateurQDO from '../images/accompagnateur-qdo.png';

import bdoCapConception from '../images/medaille-bdo-cap-conception.png'
import bdoCapRealisation from '../images/medaille-bdo-cap-realisation.png'
import bdoCapUsage from '../images/medaille-bdo-cap-usage.png'
import bdoBronzeConception from '../images/medaille-bdo-bronze-conception.png';
import bdoBronzeRealisation from '../images/medaille-bdo-bronze-realisation.png';
import bdoBronzeUsage from '../images/medaille-bdo-bronze-usage.png';
import bdoArgentConception from '../images/medaille-bdo-argent-conception.png';
import bdoArgentRealisation from '../images/medaille-bdo-argent-realisation.png';
import bdoArgentUsage from '../images/medaille-bdo-argent-usage.png';
import bdoOrConception from '../images/medaille-bdo-or-conception.png';
import bdoOrRealisation from '../images/medaille-bdo-or-realisation.png';
import bdoOrUsage from '../images/medaille-bdo-or-usage.png';

import qdoBronzeConception from '../images/medaille-qdo-bronze-conception.png';
import qdoBronzeRealisation from '../images/medaille-qdo-bronze-realisation.png';
import qdoBronzeUsage from '../images/medaille-qdo-bronze-usage.png';
import qdoArgentConception from '../images/medaille-qdo-argent-conception.png';
import qdoArgentRealisation from '../images/medaille-qdo-argent-realisation.png';
import qdoArgentUsage from '../images/medaille-qdo-argent-usage.png';
import qdoOrConception from '../images/medaille-qdo-or-conception.png';
import qdoOrRealisation from '../images/medaille-qdo-or-realisation.png';
import qdoOrUsage from '../images/medaille-qdo-or-usage.png';

import Tag from './tag';

const ItemRessource = ({data, style, tags}) => {

    const medailles = [];
    if(data.phases){
        const imagesCap = [bdoCapConception, bdoCapRealisation, bdoCapUsage];
        const imagesBronze = data.groupe === 'bdo' ? [bdoBronzeConception, bdoBronzeRealisation, bdoBronzeUsage] : [qdoBronzeConception, qdoBronzeRealisation, qdoBronzeUsage];
        const imagesArgent = data.groupe === 'bdo' ? [bdoArgentConception, bdoArgentRealisation, bdoArgentUsage] : [qdoArgentConception, qdoArgentRealisation, qdoArgentUsage]
        const imagesOr = data.groupe === 'bdo' ? [bdoOrConception, bdoOrRealisation, bdoOrUsage] : [qdoOrConception, qdoOrRealisation, qdoOrUsage];
        data.phases.forEach((phase, index) => {
            if(phase && phase !== "null" && phase !== ''){
                const type = index === 0 ? 'conception' : index === 1 ? 'réalisation' : 'usage';
                if(phase === 'cap') medailles.push({titre: `Médaille Cap ${type}`, src: imagesCap[index]});
                if(phase === 'bronze') medailles.push({titre: `Médaille de bronze ${type}`, src: imagesBronze[index]});
                if(phase === 'argent') medailles.push({titre: `Médaille d'argent ${type}`, src: imagesArgent[index]});
                if(phase === 'or') medailles.push({titre: `Médaille d'or ${type}`, src: imagesOr[index]});
            }
        });
    }
    
    const tagtype = data.type === 'acteur' ? 'secteur-activites' : 'type-operations';
    const datatags = tags[tagtype] && tags[tagtype].reduce((prev, current) => {
        if(data.tags.includes(parseInt(current.id))) prev.push(current);
        return prev;
    }, []);

    let isBDO = data.tags.includes(359);
    let isQDO = data.tags.includes(383);

    const groupes = data.groupe.split(',').filter(item => item !== '');

    return(
        <div className={'ressource-item' + (data.selected ? ' active' : '') + ' ' + data.type} style={style} onClick={() => setItemSelected(data)}>
            <div className={`vignette ${data.type}`}>
                <img src={data.vignette ? data.vignette : imgRessource} alt="Vignette" />
            </div>
            <div className="informations">
                <div>
                    <h3>{data.titre}</h3>
                    {(datatags && datatags.length > 0) && <div className='tags'>
                        {datatags.map(tag => <Tag key={tag.id}>{tag.titre}</Tag>)}
                    </div>}
                    <a className="ressource-link" href={data.url} target="_blank" rel="noreferrer">En savoir +</a>
                    <div className='groupes'>
                        {(groupes.length > 0) && 
                            groupes.map(groupe => {
                                return groupe === 'adherent' && <img key={1} className='adherent' src={imgAdherent} title='Adhérent' alt='Icône adhérent' />
                            })
                        }
                        {isBDO && <img className='accompagnateur-bdo' src={imgAccompagnateurBDO} title='Accompagnateur BDO' alt='Icône accompagnateur accompagnateur-BDO' />}
                        {isQDO && <img className='accompagnateur-qdo' src={imgAccompagnateurQDO} title='Accompagnateur QDO' alt='Icône accompagnateur QDO' />}
                        {(medailles.length > 0) && <div className="medailles">
                            {medailles.map(medaille => {
                                return <img key={medaille.src} className='bdo' src={medaille.src} title={medaille.titre} alt={medaille.titre} />
                            })}
                        </div>}
                    </div>
                </div>
            </div>
        </div>
    );

}

export default ItemRessource;